import React from 'react';
import PropTypes from 'prop-types';

import _ from 'helpers/no_conflict_lodash';
import { CopyToClipboard } from 'react-copy-to-clipboard';

class Export extends React.Component {
  static propTypes = {
    options: PropTypes.array.isRequired
  }

  state = {
    exported: false
  }

  componentDidUpdate(previousProps) {
    if (!_.isEqual(this.props.options, previousProps.options)) {
      this.setState({ exported: false });
    }
  }

  handleExport = () => {
    this.setState({ exported: true });
  }

  render() {
    const { options, ...props } = this.props;

    return (
      <React.Fragment>
        <span name="export-notification">{this.state.exported ? 'Copied! ' : null}</span>
        <CopyToClipboard text={JSON.stringify(options)} onCopy={this.handleExport}>
          <button {...props}>Export</button>
        </CopyToClipboard>
      </React.Fragment>
    );
  }
}

export default Export;
